import _ from 'lodash';
import { HttpClient } from 'api/helpers/HttpClient';

export const getRecommendedContent = params => {
const{url, hasClaroAdActive, ...restParams} = params;
const apiCall = new HttpClient({ hasClaroAdActive: hasClaroAdActive });
return apiCall
    .get(url, {
      ...restParams,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return hasClaroAdActive ? data.data : data;
      return error;
    });
}
